import { Outlet } from "react-router-dom";

const HistoryLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default HistoryLayout;